export default __webpack_public_path__ + "static/media/womenfashion.c9798cda.webp";